export const PAGE_KEY = "page";
export const PER_PAGE_KEY = "perPage";
export const SORT_KEY = "sort";
export const ARRAY_SEPARATOR = ",";
export const DEBOUNCE_MS = 300;
export const THROTTLE_MS = 50;
export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SORT = "id";
export const DEFAULT_SORT_ORDER = "asc";
